import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  Box, Chip, IconButton, TextField, Button
} from '@material-ui/core';
import { 
  Close as CloseIcon, AddCircle as AddCircleIcon, 
  ExpandLess, ExpandMore,  
} from "@material-ui/icons";
import clsx from 'clsx';
import MenuType from "./MenuType";
import styles from './Menu.module.css';
import { reqSaveSchedule } from './api';
import { useNotify } from 'react-admin';
import { Link } from 'react-router-dom';
import { OPEN_DLG_SERVICE_PLAN, selectServiceTimes } from './reducer';
import { toPriceKRW } from '../util/CommonUtils';
import { getDayKey } from './functions';

// 밀박스/부페 메뉴 
const MealBox = ({ 
  day,
  serviceTime,
  menu, 
  onClickDeleteMenu, onClickAddSubMenu, onClickDeleteSubMenu, 
  onUpdateMemo, onSaved, 
}) => {

  const notify = useNotify();

  const dispatch = useDispatch();

  const [ state, setState ] = useState({
    expanded: !menu.id,
  });
  const [ memo, setMemo ] = useState(menu.memo);

  const serviceTimes = useSelector(selectServiceTimes);

  const handleChangeAdtnMenu = evt => {
    setMemo(evt.target.value);
  }

  const handleOnBlur = () => {
    onUpdateMemo({
      date: menu.date,
      serviceTime: menu.serviceTime,
      menuId: menu.menuId,
      memo: memo
    });
  }

  const toggleExpand = () => {
    setState(prev => ({
      ...prev,
      expanded: !prev.expanded
    }));
  }

  const handleClickSave = async () => {
    try {
      const { data } = await reqSaveSchedule(menu);
      // update 
      const { id, date, serviceTime, menuId } = data;
      onSaved({ id, date, serviceTime, menuId });
    } catch (err) {
      console.error(err)
      notify(`스케줄 저장에 실패했습니다.\n${err}`, 'error')
    }    
  }

  const handleClickPlan = () => {
    dispatch({
      type: OPEN_DLG_SERVICE_PLAN,
      payload: {
        menu,
      }
    });
  }

  return (
    <div className={styles.menu}>
      {/* supplier title */}
      <div className={styles.supplier}>
        <div className={styles.supplierTitle}>
          {menu.supplier.name}
        </div>
        <div>
          <Status 
            menu={menu}
            onClickDeleteMenu={onClickDeleteMenu}
          />
        </div>
      </div>
      {/* main menu */}
      <div className={styles.mainMenu}>
        <MenuType type={'메인메뉴'} />
        <div className={styles.menuTitle}
        >
          <Link 
            to={`/menus/${menu.menu.id}`}
            target="_blank"
            style={{ 
              color: '#000000',
            }}
          >
            {menu.menu.name}
          </Link>
        </div>
        <PriceInfo 
          day={day}
          serviceTime={serviceTime}
          menu={menu}
          serviceTimes={serviceTimes}
          onClick={handleClickPlan}
        />
      </div>
      {/* sub menu */}
      <div>
        <div className={styles.subMenu}>
          <MenuType type={'서브메뉴'} />
          <div>
          {!menu.published &&
            <IconButton 
              aria-label="add submenu"
              size="small"
              onClick={onClickAddSubMenu}
              data-date={menu.date}
              data-servicetime={menu.serviceTime}
              data-menuid={menu.menuId}
            >
              <AddCircleIcon fontSize="small" />
            </IconButton>}
          </div>
        </div>
        <Box>
        {menu.subMenu.map((sm, i) => (
          <Chip 
            className={styles.subMenuItem}
            key={i}
            variant="outlined"
            size="small"
            label={sm.name}
            onDelete={onClickDeleteSubMenu}
            data-date={menu.date}
            data-servicetime={menu.serviceTime}
            data-menuid={menu.menuId}
            data-submenuid={sm.id}
            disabled={menu.published}
          />
        ))}
        </Box>
      </div>
      {/* memo */}
      <div className={styles.adtnMenu}>
        <MenuType type={'추가메뉴'} />
        <div
          className={styles.memo}
        >
          <TextField 
            value={memo ?? ''}
            onChange={handleChangeAdtnMenu}
            onBlur={handleOnBlur}
            variant="outlined"
            placeholder="메인 옆에 '추가메뉴명'으로 적용됨"
            size="small"
            disabled={menu.published}
          />
        </div>
      </div>
      <div>
        {state.expanded ? 
        <IconButton 
          aria-label="expand less"
          size="small"
          onClick={toggleExpand} >
          <ExpandLess fontSize="small" />
        </IconButton> :
        <IconButton
          aria-label="expand more"
          size="small"
          onClick={toggleExpand}>
          <ExpandMore fontSize="small" />
        </IconButton>}
        {state.expanded && 
        <div>
          {menu.published ? 
          <PatchDelete /> : 
          <SaveOrUpdate 
            menu={menu}
            onClickSave={handleClickSave}
          />}
        </div>}
      </div>
    </div>
  );
}

const Status = ({ menu, onClickDeleteMenu }) => {

  // delete(local) 

  // saved | published | patch-deleted 
  
  const canPatch = !!menu.customerPrice;

  return (
    <div>
      {menu.id && 
      <span className={clsx(
        styles.status, 
        {[styles.published]: menu.published},
        {[styles.cannotPatch]: !canPatch}
      )}>
        {menu.id}
      </span>}
      {!menu.published && 
      <>
      <IconButton 
        aria-label="delete"
        size="small"
        onClick={onClickDeleteMenu}
        data-date={menu.date}
        data-servicetime={menu.serviceTime}
        data-menuid={menu.menuId}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      </>}
    </div>
  );
}

const PriceInfo = ({ 
  day, 
  serviceTime,
  menu, 
  serviceTimes, 
  onClick 
}) => {

  // publish 된 경우는 적용된 가격 제공 
  if (menu.published) {
    return (
      // TODO styled 
      <div className={styles.priceInfo}>
        {toPriceKRW(menu.customerPrice)}
        &nbsp;({toPriceKRW(menu.supplierPrice)})
      </div>
    );
  }

  /* // legacy 호환성
  if (!menu.servicePlanId) {
    return null;
  } */

  // TODO useMemo ? 
  const pricingModel = calcPricingModel(serviceTimes, day, serviceTime, menu);
  const menuPrice = menu.menu?.price ?? menu.supplierPrice;

  if (pricingModel === 'product-based') {
    return (
      <div className={clsx(styles.priceInfo, styles.clickable)}
        onClick={onClick}
      >
        {(menu.sellingPrice ? toPriceKRW(menu.sellingPrice) : '!판매가 없음') + 
          ` (${toPriceKRW(menuPrice)})`}
      </div>
    );
  }

  let price;
  if (menu.servicePlanId) {
    for (const st of serviceTimes) {
      const sp = st.servicePlan.find(p => p.id === menu.servicePlanId);
      if (sp) {
        price = sp.tierPrice || st.price;
        break;
      }
    }
  }
  else {
    // legacy (servicePlanId 없는 경우)
    const st = calServiceTime(serviceTimes, day, serviceTime);
    const plan = st?.servicePlan[0];
    price = plan?.tierPrice ?? st?.price;
  }
  
  return (
    <div 
      className={clsx(styles.priceInfo, styles.clickable)}
      onClick={onClick}
    >
      {(price ? toPriceKRW(price) : '가격정보 없음') + 
        ` (${toPriceKRW(menuPrice)})`}
    </div>
  );
}

const SaveOrUpdate = ({ menu, onClickSave }) => {

  return (
    <div>
      <Button 
        onClick={onClickSave}
        disabled={menu.id}      // TODO 
      >
        {menu.id ? 'Update' : 'Save'}
      </Button>
    </div>
  )
}

const PatchDelete = () => {

  return (
    <div>
      patch deletion
    </div>
  )
}

export default MealBox;


const calServiceTime = (serviceTimes, day, serviceTime) => {
  // serviceTime, day 로 찾기 
  const dayKey = getDayKey(day);
  for (const st of serviceTimes) {
    if (st.serviceTime === serviceTime && st[dayKey]) {
      // TODO check service type ? 
      return st;
    }
  }

  // day 안 맞는 경우, serviceTime 기준 (운영 정책따라 변경될 수 있음)
  for (const st of serviceTimes) {
    if (st.serviceTime === serviceTime) {
      // TODO check service type ? 
      return st;
    }
  }

  return null;
}

const calcPricingModel = (serviceTimes, day, serviceTime, menu) => {
  // servicePlanId 있는 경우 
  if (menu?.servicePlanId) {
    for (const st of serviceTimes) {
      const sp = st.servicePlan.find(p => p.id === menu.servicePlanId);
      if (sp) {
        return sp.pricingModel;
      }
    }
  }

  const st = calServiceTime(serviceTimes, day, serviceTime);
  return st?.servicePlan[0]?.pricingModel ?? 'tiered';
}